import { convertDateTime, convertMillisecondsToRecord } from 'utils/time';
// make the initial page sort by the filterOptions.js layout
import { clubFilterOptions } from 'config/admin/filterOptions';

export const getOfficialRecordTableSortData = (records) => {
  const tableRecords = [];

  records.forEach((record) => {
    tableRecords.push({
      ...record,
      timestamp: convertDateTime(record.achievedAt).date,
      ageGroup: record.athleteAge,
      result:
        [
          'Discus',
          'Javelin',
          'Shot Put',
          'High Jump',
          'Long Jump',
          'Triple Jump',
          'Vortex',
        ].indexOf(record.eventType) > -1
          ? `${parseFloat(record?.recordValue).toFixed(2)} m`
          : `${convertMillisecondsToRecord(record?.recordValue, 2)}`,
    });
  });

  // // Sort by event first by using the order defined in filterOptions.js
  return tableRecords.sort((a, b) => {
    const eventOrder = clubFilterOptions.eventType.values;
    if (a.eventType !== b.eventType)
      return eventOrder.indexOf(a.eventType) - eventOrder.indexOf(b.eventType);

    // Sort by age numerically
    const aAge = parseInt(a.ageGroup);
    const bAge = parseInt(b.ageGroup);
    if (aAge !== bAge) {
      return aAge - bAge;
    }

    // If ages are equal sort by gender
    if (a.gender !== b.gender) {
      return a.gender === 'Female' ? -1 : 1;
    }

    return 0;
  });
};

export const getPendingRecordTableSortData = (records) => {
  const tableRecords = [];

  records.forEach((record) => {
    tableRecords.push({
      ...record,
      ageGroup: record.athleteAge,
      athleteName: `${record.athleteFirstName} ${record.athleteLastName}`,
      timestamp: convertDateTime(record.meetDate).date,
      result:
        [
          'Discus',
          'Javelin',
          'Shot Put',
          'High Jump',
          'Long Jump',
          'Triple Jump',
          'Vortex',
        ].indexOf(record.eventType) > -1
          ? `${parseFloat(record?.performanceValue).toFixed(2)} m`
          : `${convertMillisecondsToRecord(record?.performanceValue, 2)}`,
    });
  });

  // Sort by event first by using the order defined in filterOptions.js
  return tableRecords.sort((a, b) => {
    const eventOrder = clubFilterOptions.eventType.values;
    if (a.eventType !== b.eventType)
      return eventOrder.indexOf(a.eventType) - eventOrder.indexOf(b.eventType);

    // Sort by age numerically
    const aAge = parseInt(a.ageGroup);
    const bAge = parseInt(b.ageGroup);
    if (aAge !== bAge) {
      return aAge - bAge;
    }

    // If ages are equal sort by gender
    if (a.gender !== b.gender) {
      return a.gender === 'Female' ? -1 : 1;
    }

    return 0;
  });
};
